import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import * as VueGoogleMaps from 'vue2-google-maps'
import formatcoords from 'formatcoords'
import lodash from 'lodash'
import moment from 'moment'
import momenttz from 'moment-timezone'
import SimpleVueValidator from 'simple-vue-validator';
import VueDatepickerLocal from 'vue-datepicker-local'

Vue.use(BootstrapVue)
Vue.use(SimpleVueValidator);
Vue.component('datepicker', VueDatepickerLocal);

// define external javascript library
Object.defineProperty(Vue.prototype, '$formatcoords', { value: formatcoords })
Object.defineProperty(Vue.prototype, '$_', { value: lodash })
Object.defineProperty(Vue.prototype, '$moment', { value: moment })
Object.defineProperty(Vue.prototype, '$momenttz', { value: momenttz })

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.GOOGLE_API_KEY,
    libraries: 'places,drawing,geometry'
  }
})

// Filters
Vue.filter('formatDate', function(value, format) {
  let d = moment(value)
  if ( value && d.isValid() ) {
  	   //return moment(value).tz('Asia/Riyadh').format( format )
  	   return moment(value).format( format )
  } 
})

Vue.filter('formatBoolean', function(value, format) {
	return (value) ? 'Yes' : 'No'
})


// WEBPACK FOOTER //
// ./src/plugins.js